export enum ChallengeAttribute {
  Correct = 530,
  Incorrect = 531,
}
